const MONO = "'JetBrains Mono', monospace"

export const PRIVILEGE_TAGS = [
    { key: "pushkin_card" as const, label: "Пушкинская карта", color: "#349be6" },
    { key: "invitational" as const, label: "Пригласительные", color: "#29cc6a" },
    { key: "child_place" as const, label: "Детям бесплатно", color: "#e4206b" },
    { key: "discount" as const, label: "Скидка", color: "#e4206b" },
]

export default function PrivilegeTag({ label, color }: { label: string; color: string }) {
    return (
        <span
            className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] uppercase whitespace-nowrap border"
            style={{
                fontFamily: MONO,
                fontWeight: 700,
                color,
                borderColor: `${color}55`,
                background: `${color}18`,
                letterSpacing: "0.06em",
            }}>
            {label}
        </span>
    )
}
